/** Сведения о сборке — для экрана «Ещё» и отчётов о сбоях. */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';
export const BUILD_STAMP: string = typeof __BUILD_TS__ === 'string' ? __BUILD_TS__ : 'dev';
export const OTA_VERSION: string = typeof __OTA_VERSION__ === 'string' ? __OTA_VERSION__ : 'dev';
